<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10">
      <div class="max-w-6xl px-8 w-full mx-auto">
        <div class="flex items-center justify-between w-full h-20 gap-2">
          <slot name="start" />
          <div class="flex gap-2 items-center">
            <slot name="end" />
          </div>
        </div>
      </div>
    </header>
    <main class="flex-1 overflow-y-auto">
      <div class="w-full h-full">
        <slot name="default" />
      </div>
    </main>
  </section>
</template>
